
import { Mantra, SatsangAudio } from './types';

export const TARGET_GOAL = 3000000; // Monthly Minimum: 30 Lakhs per mantra
export const APP_NAME = "गोलोक दिव्य नाम कोष";
export const BRAND_NAME = "Golok Prem Ras";

export const DEFAULT_MANTRAS: Mantra[] = [
  { 
    id: 'ram', 
    label: 'Ram', 
    hindiLabel: 'राम', 
    placeholder: 'राम',
    heading: 'श्री राम जय राम जय जय राम', 
    subtext: 'Type "Ram" or "राम"',
    patterns: ['^ram$', '^राम$'],
    keypadKeys: ['र', 'ा', 'म']
  },
  { 
    id: 'radha', 
    label: 'Radha', 
    hindiLabel: 'राधा', 
    placeholder: 'राधा',
    heading: 'राधा राधा', 
    subtext: 'Type "Radha" or "राधा"',
    patterns: ['^radha$', '^राधा$'],
    keypadKeys: ['र', 'ा', 'ध', 'ा']
  },
  { 
    id: 'radhakrishna', 
    label: 'RadhaKrishna', 
    hindiLabel: 'राधाकृष्ण', 
    placeholder: 'राधाकृष्ण',
    heading: 'राधा कृष्ण राधा कृष्ण', 
    subtext: 'Type "RadhaKrishna" or "राधाकृष्ण"',
    patterns: ['^radhakrishna$', '^radha\\s?krishna$', '^राधाकृष्ण$', '^राधा\\s?कृष्ण$'],
    keypadKeys: ['र', 'ा', 'ध', 'ा', 'क', 'ृ', 'ष', '्', 'ण']
  },
  { 
    id: 'sitaram', 
    label: 'SitaRam', 
    hindiLabel: 'सीताराम', 
    placeholder: 'सीताराम',
    heading: 'सीता राम सीता राम', 
    subtext: 'Type "SitaRam" or "सीताराम"',
    patterns: ['^sitaram$', '^sita\\s?ram$', '^सीताराम$', '^सीता\\s?राम$'],
    keypadKeys: ['स', 'ी', 'त', 'ा', 'र', 'ा', 'म']
  },
  { 
    id: 'sambsadashiv', 
    label: 'Samb Sadashiv', 
    hindiLabel: 'सांब सदाशिव', 
    placeholder: 'सांब सदाशिव',
    heading: 'सांब सदाशिव', 
    subtext: 'Type "Samb Sadashiv" or "सांब सदाशिव"',
    patterns: ['^samb\\s?sadashiv$', '^saamba\\s?sadaashiva$', '^सांब\\s?सदाशिव$', '^सांबसदाशिव$'],
    keypadKeys: ['स', 'ा', 'ं', 'ब', 'स', 'द', 'ा', 'श', 'ि', 'व']
  },
  { 
    id: 'mahamantra', 
    label: 'Maha Mantra', 
    hindiLabel: 'महामंत्र', 
    placeholder: 'हरे कृष्ण हरे कृष्ण कृष्ण कृष्ण हरे हरे, हरे राम हरे राम राम राम हरे हरे',
    heading: 'हरे कृष्ण हरे कृष्ण कृष्ण कृष्ण हरे हरे, हरे राम हरे राम राम राम हरे हरे', 
    subtext: 'Type full 16-word mantra', 
    patterns: [
      '^hare\\s?krishna\\s?hare\\s?krishna\\s?krishna\\s?krishna\\s?hare\\s?hare\\s?,?\\s?hare\\s?rama\\s?hare\\s?rama\\s?rama\\s?rama\\s?hare\\s?hare$',
      '^हरे\\s?कृष्ण\\s?हरे\\s?कृष्ण\\s?कृष्ण\\s?कृष्ण\\s?हरे\\s?हरे\\s?,?\\s?हरे\\s?राम\\s?हरे\\s?राम\\s?राम\\s?राम\\s?हरे\\s?हरे$'
    ],
    keypadKeys: ['हरे', 'कृष्ण', 'राम']
  },
  { 
    id: 'shriharivansh', 
    label: 'Shri Harivansh', 
    hindiLabel: 'श्री हरिवंश', 
    placeholder: 'श्री हरिवंश',
    heading: 'श्री हरिवंश', 
    subtext: 'Type "Shri Harivansh" or "श्री हरिवंश"',
    patterns: ['^shri\\s?harivansh$', '^shriharivansh$', '^श्री\\s?हरिवंश$', '^श्रीहरिवंश$'],
    keypadKeys: ['श्री', 'ह', 'रि', 'वं', 'श']
  },
  { 
    id: 'radhavallabh', 
    label: 'Radha Vallabh Shri Harivansh', 
    hindiLabel: 'राधावल्लभ श्रीहरिवंश', 
    placeholder: 'राधावल्लभ श्रीहरिवंश',
    heading: 'राधावल्लभ श्रीहरिवंश', 
    subtext: 'Type "Radha Vallabh Shri Harivansh"',
    patterns: ['^radha\\s?vallabh\\s?shri\\s?harivansh$', '^radhavallabh\\s?shriharivansh$', '^राधावल्लभ\\s?श्रीहरिवंश$', '^राधावल्लभश्रीहरिवंश$'],
    keypadKeys: ['रा', 'धा', 'व', 'ल्ल', 'भ', ' ', 'श्री', 'ह', 'रि', 'वं', 'श']
  },
  { 
    id: 'shriharidas', 
    label: 'Shri Haridas', 
    hindiLabel: 'श्री हरिदास', 
    placeholder: 'श्री हरिदास',
    heading: 'श्री हरिदास', 
    subtext: 'Type "Shri Haridas" or "श्री हरिदास"',
    patterns: ['^shri\\s?haridas$', '^shriharidas$', '^श्री\\s?हरिदास$', '^श्रीहरिदास$'],
    keypadKeys: ['श्री', 'ह', 'रि', 'दा', 'स']
  },
  { 
    id: 'kunjbihari', 
    label: 'Kunj Bihari Shri Haridas', 
    hindiLabel: 'कुंज बिहारी श्री हरिदास', 
    placeholder: 'कुंज बिहारी श्री हरिदास',
    heading: 'कुंज बिहारी श्री हरिदास', 
    subtext: 'Type "Kunj Bihari Shri Haridas"',
    patterns: ['^kunj\\s?bihari\\s?shri\\s?haridas$', '^कुंज\\s?बिहारी\\s?श्री\\s?हरिदास$'],
    keypadKeys: ['कुंज', 'बिहारी', 'श्री', 'हरिदास']
  },
  { 
    id: 'shriramjayram', 
    label: 'Shri Ram Jay Ram Jay Jay Ram', 
    hindiLabel: 'श्री राम जय राम जय जय राम', 
    placeholder: 'श्री राम जय राम जय जय राम',
    heading: 'श्री राम जय राम जय जय राम', 
    subtext: 'Type full mantra',
    patterns: ['^shri\\s?ram\\s?jay\\s?ram\\s?jay\\s?jay\\s?ram$', '^श्री\\s?राम\\s?जय\\s?राम\\s?जय\\s?जय\\s?राम$'],
    keypadKeys: ['श्री', 'राम', 'जय']
  }
];

// Sample silent audio (base64 encoded minimal MP3 for testing)
const SAMPLE_AUDIO_DATA = 'data:audio/mp3;base64,//uQxAAAAAANIAAAAAExBTUUzLjEwMFVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVf/7kMQAD8AAADSAAAAAAAANIAAAAARVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVU=';

export const DEFAULT_AUDIOS: SatsangAudio[] = [
  {
    id: 'sample-audio-1',
    title: 'श्री राम जय राम - भजन',
    speaker: 'Pujya Bhaiji Hanuman Prasad Poddar Ji',
    category: 'Pujya Bhaiji Hanuman Prasad Poddar Ji Satsang',
    audioData: SAMPLE_AUDIO_DATA,
    active: true,
    uploadedAt: new Date().toISOString()
  },
  {
    id: 'sample-audio-2',
    title: 'राधा कृष्ण भजन - Divine Melody',
    speaker: 'Pujya Seth Shri Jayadayal Goendka Ji',
    category: 'Pujya Seth Shri Jayadayal Goendka Ji Satsang',
    audioData: SAMPLE_AUDIO_DATA,
    active: true,
    uploadedAt: new Date().toISOString()
  },
  {
    id: 'sample-audio-3',
    title: 'गीता प्रवचन - अध्याय २',
    speaker: 'Pujya Swami Shri Ramsukhdas Ji',
    category: 'Pujya Swami Shri Ramsukhdas Ji Satsang',
    audioData: SAMPLE_AUDIO_DATA,
    active: true,
    uploadedAt: new Date().toISOString()
  }
];
